
export const categoria_selecionada = {
  computed: {
    categoria_selecionada: {
      get() {
        return this.$store.getters["compraMateriaPrima/categoria_selecionada"];
      },
      set(categoria) {
        return this.$store.dispatch("compraMateriaPrima/categoria_selecionada", categoria);
      }
    }
  },
  destroyed() {
    this.categoria_selecionada = null;
  }
}
